import styled, { css } from "styled-components/macro";
import { motion } from "framer-motion";
import { rgba } from "polished";
import {
  colors,
  space,
  borderRadius,
  fontSize,
  transition,
} from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";
import { MutedText } from "shared/styles";
import { IFormFieldStyle } from "shared/types";

interface FieldWrapperContainerProps {
  style?: IFormFieldStyle;
}

export const FieldWrapperContainer = styled.div<FieldWrapperContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const FieldWrapperChildren = styled.div`
  position: relative;
`;

interface InputFieldWrapperProps {
  error?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isFocused?: boolean;
  isPadded?: boolean;
}

export const InputFieldWrapper = styled.div<InputFieldWrapperProps>`
  display: flex;
  align-items: center;

  width: 100%;

  background-color: ${colors.white};
  border-radius: ${borderRadius.xs};

  color: ${colors.black};
  ${fontSize.base}

  transition: box-shadow ${transition.default};

  ${hoverFocus.defaultFocus};

  ${({ isPadded }) =>
    isPadded &&
    css`
      padding: calc(${space.s} - 1px) ${space.m} ${space.s};
    `}

  ${({ isReadOnly, isDisabled }) =>
    (isReadOnly || isDisabled) &&
    css`
      opacity: 0.6;
      color: ${rgba(colors.black, 0.6)};
      cursor: not-allowed;
    `}

  ${({ isFocused }) =>
    isFocused &&
    css`
      ${hoverFocus.focusStyle}
    `}

  ${({ error }) =>
    error &&
    css`
      box-shadow: 0 0 0 2px ${colors.red};
    `}
`;

export const InputFieldStyles = css`
  /* safari fix */
  margin: 0;

  width: 100%;
  padding: calc(${space.s} - 1px) ${space.m} ${space.s};
  outline: none;
  background-color: transparent;

  color: inherit;
  font-family: inherit;
  text-align: left;

  border-radius: inherit;

  cursor: inherit;
`;

export const StyledInputField = styled.input`
  ${InputFieldStyles}
`;

export const Suffix = styled.span`
  display: flex;
  align-items: center;

  padding: ${space.xs} ${space.xs} ${space.xs} 0;

  color: ${colors.grey4};
`;

export const Note = styled(MutedText)`
  margin: ${space.xs} 0;
`;

export const ErrorMessage = styled(motion(MutedText))`
  margin-top: ${space.xs};

  color: ${colors.redLight};
`;
